import { Helmet } from "react-helmet-async";
import { services } from "../data";
import ServiceCard from "../components/ServiceCard";
import SectionHeader from "../components/SectionHeader";

export default function Services() {
  return (
    <main className="page-top section-padding">
      <Helmet><title>Services | VRGlobal Tech</title></Helmet>
      <div className="container">
        <SectionHeader eyebrow="Services" title="Professional software and digital services" text="Choose complete technology support for business automation, online visibility and infrastructure." />
        <div className="row g-4 mt-3">
          {services.map((service) => <div className="col-md-6 col-lg-4" key={service.title}><ServiceCard service={service} /></div>)}
        </div>
      </div>
    </main>
  );
}
